import { render, staticRenderFns } from "./RealmDetail.vue?vue&type=template&id=5c24ee1d&scoped=true&"
import script from "./RealmDetail.vue?vue&type=script&lang=js&"
export * from "./RealmDetail.vue?vue&type=script&lang=js&"
import style0 from "./RealmDetail.vue?vue&type=style&index=0&id=5c24ee1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c24ee1d",
  null
  
)

export default component.exports